import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import { useState, useEffect, useRef } from 'react';

var useIsTouchDevice = function useIsTouchDevice() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isTouchDevice = _useState2[0],
      setIsTouchDevice = _useState2[1];

  var isMounted = useRef(false);
  useEffect(function () {
    isMounted.current = true;
    var checkIfTouchDevice = function checkIfTouchDevice() {
      return 'ontouchstart' in window || navigator.maxTouchPoints;
    };
    if (checkIfTouchDevice()) {
      setIsTouchDevice(true);
    }
    return function () {
      isMounted.current = false;
    };
  }, []);

  return isTouchDevice;
};

export default useIsTouchDevice;